export const RQ_UPDATE_PROFILE_API = {
  url: 'api/admin/update/<%= role %>/<%= id %>',
  method: 'PUT',
  auth: true,
};
